export type OnboardingRouteState = {
  hasCompletedOnboarding?: boolean;
  onboardingSkippedAt?: Date | string | null;
};

export type AfterAuthDestination = {
  path: string;
  showOnboarding: boolean;
  reason: 'completed' | 'skipped' | 'incomplete';
};

/**
 * After sign-in, completed users go to the product.
 * Skipped users also go to the product (no false activation) and can resume later.
 * Users who never started or never skipped resume the wizard.
 */
export function nextRouteAfterAuth(state: OnboardingRouteState): AfterAuthDestination {
  if (state.hasCompletedOnboarding === true) {
    return { path: '/my-golf-bag', showOnboarding: false, reason: 'completed' };
  }
  if (state.onboardingSkippedAt) {
    return { path: '/my-golf-bag', showOnboarding: false, reason: 'skipped' };
  }
  return { path: '/my-golf-bag', showOnboarding: true, reason: 'incomplete' };
}

export function canResumeOnboarding(state: OnboardingRouteState): boolean {
  return state.hasCompletedOnboarding !== true;
}
